(function ($) {

    if ($('body.search').length || $('body.single-post').length) {

        $(window).on('resize load', function () {
            var height = $(window).height() - $('header').outerHeight() - $('.subfooter-section').outerHeight() - $('.footer-section').outerHeight() - $('footer').outerHeight();
            $('.main-page-wrap>.container').css('min-height', height);
        });

    }

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/search-page.es6